import { useEffect } from "react";
import { Link, Outlet, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "../common/Button";
import { getDisplayNameRedirectPath } from "../settings/EditDisplayName";
import StyledFirebaseAuth from "./StyledFirebaseAuth";
import { useUserContext } from "./UserProvider";

export const Login = () => {
  const [searchParams] = useSearchParams();
  const redirectUrlFromQuery = searchParams.get("redirect");
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading, } = useUserContext();

  useEffect(() => {
    // first login & no displayname set
    if (user && user.metadata.creationTime === user.metadata.lastSignInTime) {
      const redirect = redirectUrlFromQuery ?? "/"
      navigate(getDisplayNameRedirectPath(redirect));
      return
    }
    // normal login
    if (user && redirectUrlFromQuery) {
      navigate(redirectUrlFromQuery);
      return
    }
    if (user && location.pathname.startsWith("/login")) {
      navigate("/");
      return
    }
  }, [user, redirectUrlFromQuery, navigate]);

  return (
    <>
      <div className="w-full text-2xl text-center pt-6">Wister</div>
      {loading && <LoadingAnimation />}
      <Outlet />
    </>
  );
};

export const LoadingAnimation = () => {
  return (
    <div className="absolute z-50 top-0 right-0 w-full h-full bg-slate-800 opacity-60 flex flex-col items-center justify-center text-slate-50">
      <svg aria-hidden="true" className="mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-slate-50" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
      </svg>
    </div>
  );
}

export const DefaultLoginPage = () => {
  const { signInWithGoogle, signInWithFacebook } = useUserContext();
  return (
    <DefaultLogin
      signInWithGoogle={signInWithGoogle}
      signInWithFacebook={signInWithFacebook} />
  );
}

const DefaultLogin = ({ signInWithGoogle, signInWithFacebook }) => {
  return (
    <div className="px-2 flex flex-col gap-1">
      <StyledFirebaseAuth signInWithGoogle={signInWithGoogle} signInWithFacebook={signInWithFacebook} />
      <Link to="/login/email">
        <Button>Login with email and password</Button>
      </Link>

      <Link to="/login/register">
        <Button>Create a new account</Button>
      </Link>
    </div>
  );
}
